import { Box, Button, CircularProgress, MenuItem, Typography } from "@mui/material";
import { PinnacleTextField } from "../../../components/PinnacleTextField";
import { E_FIELD_REQUIRED } from "../../../utils/constants";
import { Program } from "../../../api/interfaces/Program";
import { FormData } from "../TermsPage";

interface CreateTermDrawerContentProps {
  formData: FormData;
  touchedFields: Record<keyof FormData, boolean>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur: (field: keyof FormData) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  programs: Program[];
  isFormValid: () => boolean;
}

const CreateTermDrawerContent: React.FC<CreateTermDrawerContentProps> = ({
  formData,
  touchedFields,
  onChange,
  onBlur,
  onSubmit,
  isSubmitting,
  programs,
  isFormValid
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <PinnacleTextField
        label="Name"
        name="name"
        value={formData.name}
        onChange={onChange}
        fullWidth
        onBlur={() => onBlur('name')}
        error={touchedFields.name && !formData.name.trim()}
        helperText={
          touchedFields.name && !formData.name.trim()
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      />

      <PinnacleTextField
        label="Description"
        name="description"
        value={formData.description}
        onChange={onChange}
        multiline
        rows={3}
        fullWidth
        onBlur={() => onBlur('description')}
        error={touchedFields.description && !formData.description.trim()}
        helperText={
          touchedFields.description && !formData.description.trim()
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      />

      <PinnacleTextField
        select
        label="Program"
        name="programId"
        value={formData.programId}
        onChange={onChange}
        fullWidth
        onBlur={() => onBlur('programId')}
        error={touchedFields.programId && !formData.programId.trim()}
        helperText={
          touchedFields.programId && !formData.programId.trim()
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      >
        {programs.map((program: Program) => (
          <MenuItem key={program._id} value={program._id}>
            <Typography
              noWrap
              sx={{
                maxWidth: '400px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
              }}
            >
              {program.name}
            </Typography>
          </MenuItem>
        ))}
      </PinnacleTextField>

      <PinnacleTextField
        label="Start Date"
        type="date"
        name="startDate"
        value={formData.startDate || ''}
        onChange={onChange}
        InputLabelProps={{ shrink: true }}
        fullWidth
        onBlur={() => onBlur('startDate')}
        error={touchedFields.startDate && !formData.startDate}
        helperText={
          touchedFields.startDate && !formData.startDate
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      />

      <PinnacleTextField
        label="End Date"
        type="date"
        name="endDate"
        value={formData.endDate || ''}
        onChange={onChange}
        InputLabelProps={{ shrink: true }}
        fullWidth
        onBlur={() => onBlur('endDate')}
        error={touchedFields.endDate && !formData.endDate}
        helperText={
          touchedFields.endDate && !formData.endDate
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={onSubmit}
        disabled={isSubmitting || !isFormValid()}
        startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
      >
        CREATE
      </Button>
    </Box>
  );
};

export default CreateTermDrawerContent;